/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

interface IAlertProps {
    message: string;
    details?: string;
    correlationId?: string;
}

const CheckoutAlert: React.FC<IAlertProps> = ({ message, details, correlationId }) => (
    <p className='ms-checkout__error-message' role='alert' aria-live='assertive'>
        <span className='ms-checkout__error-message__message'>{message}</span>
        {details ? <div className='ms-checkout__error-message__details'>{details}</div> : null}
        {correlationId
            ?
                <div className='ms-checkout__error-message__correlationId'>
                    Correlation Id: {correlationId}
                </div>
            : null}
    </p>
);

export default CheckoutAlert;
